import { DatePickerInput } from "@mantine/dates";
import { IconCalendar } from "@tabler/icons-react";
import classNames from "classnames";
import dayjs from "dayjs";
import type { CSSProperties } from "react";
import {
  toMantineDateBound,
  toMantineDateString,
} from "src/utils/mantineDates";

import styles from "./DateInput.module.scss";

interface DateInputProps {
  id: string;
  value: string;
  placeholder?: string;
  readonly?: boolean;
  outline?: string;
  textStyle?: CSSProperties;
  withIcon?: boolean;
  className?: string;
  onChange: (value: string) => void;
  // Mantine styles overrides
  variant?: string;
  forwardDate?: boolean;
}

export function DateInput({
  id,
  value,
  readonly,
  className,
  onChange,
  textStyle,
  variant,
  withIcon,
  forwardDate = true,
}: DateInputProps) {
  const maxDate = !forwardDate ? new Date() : undefined;

  return (
    <DatePickerInput
      id={id}
      className={classNames(
        styles.input,
        readonly && styles.readonly,
        className,
      )}
      maxDate={toMantineDateBound(maxDate)}
      valueFormat="DD MMM YYYY"
      readOnly={!!readonly}
      dropdownType="popover"
      variant={variant}
      rightSection={withIcon && <IconCalendar size={16} />}
      styles={{
        input: {
          fontSize: "inherit",
          color: "inherit",
          ...(textStyle as any),
        },
      }}
      popoverProps={{
        position: "bottom-start",
        withinPortal: true,
        zIndex: 1000,
      }}
      value={toMantineDateString(value)}
      onChange={val => {
        onChange(val ? dayjs(val).format("YYYY-MM-DD") : "");
      }}
    />
  );
}
